import BigNumber from "bignumber.js";

const genName = (token) => {
  return 'MORONS';
}

export const nftName = (token) => `${genName(token)} #${token.pid}`

export const experienceScale = (experience) => experience.div(new BigNumber(10).pow(process.env.REACT_APP_DECIMALS)).div(100);
